import React,{createContext,useCallback,useContext,useEffect,useId,useMemo,useState} from 'react';
export const ReportTargetsContext=createContext(null);
export function ReportTargetsProvider({children}){
 const [groups,setGroups]=useState({});
 const register=useCallback((key,items)=>setGroups(old=>({...old,[key]:items})),[]);
 const unregister=useCallback(key=>setGroups(old=>{const next={...old};delete next[key];return next;}),[]);
 const targets=useMemo(()=>Object.values(groups).flat(),[groups]);
 const value=useMemo(()=>({targets,register,unregister}),[targets,register,unregister]);
 return <ReportTargetsContext.Provider value={value}>{children}</ReportTargetsContext.Provider>;
}
export function useReportTargets(items){
 const context=useContext(ReportTargetsContext),key=useId(),register=context?.register,unregister=context?.unregister;
 const encoded=JSON.stringify(items);
 useEffect(()=>{if(!register)return;register(key,JSON.parse(encoded));return()=>unregister(key);},[key,encoded,register,unregister]);
}
